import React, { FC } from 'react'

interface Props {
  size?: number
  color?: string
  className?: string
}

const ChatInputExpandIcon: FC<Props> = ({
  size = 32,
  color = '#FFFFFF',
  className = '',
}) => {
  return (
    <div style={{ width: size, height: size }} className={className}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        {/* Background circle with 10% opacity */}
        <ellipse
          cx="16"
          cy="16"
          rx="10"
          ry="10"
          fill={color}
          fillOpacity="0.1"
        />
        {/* Arrow up icon */}
        <path
          d="M12 18L16 14L20 18"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ChatInputExpandIcon
